export class WebhookV1StandardPayloadCreditsUsageArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "creditsNotification",
            "baseName": "creditsNotification",
            "type": "WebhookV1CreditsNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadCreditsUsageArguments.attributeTypeMap;
    }
    constructor() {
    }
}
